import React from 'react'
import PublicPageSF from '../../templates/PublicPageSF'
import CardUI from '../../widgets/layout/CardUI'
import SwitchUI from '../../widgets/action/SwitchUI'
import FormUI from '../../widgets/form/FormUI'
import InputTextUI from '../../widgets/form/InputTextUI'
import './WidgetsPage.css'

const WidgetsPageUI = ({context, support, messages}) =>
  <PublicPageSF context={context} className='pg_widgets'>
    <div>
      <section>
        <CardUI context={context} title='Title'>
          This is CardUI
        </CardUI>
      </section>

      <section>
        <SwitchUI context={context} />
      </section>

      <section>
        <CardUI context={context}>
          <FormUI context={context} buttonLabel='Xyz Abc' errorList={[]}>
            <div>This is FormUI</div>
            <InputTextUI type='text' name='demo' value='hello world' label='Label' onChange={() => {}} />
            <InputTextUI type='text' name='demo2' value='hello' label='Label2' onChange={() => {}} />
          </FormUI>
        </CardUI>
      </section>
    </div>
  </PublicPageSF>

export default WidgetsPageUI
